import { TabsClasses, Theme } from '@mui/material';
import { OverridesStyleRules } from '@mui/material/styles/overrides';

export const MUI_LINK_OVERRIDES: Partial<OverridesStyleRules<keyof TabsClasses, 'MuiLink', Theme>> =
  {
    root: ({ theme }) => ({
      cursor: 'pointer',
      color: theme.palette.primary.light,
      textDecoration: 'underline',

      '&:hover': {
        color: theme.palette.primary.light,
        textDecoration: 'none',
      },
    }),
  };
